import { render, staticRenderFns } from "./InvoiceNotice.vue?vue&type=template&id=ded2189c&scoped=true&"
import script from "./InvoiceNotice.vue?vue&type=script&lang=js&"
export * from "./InvoiceNotice.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceNotice.vue?vue&type=style&index=0&id=ded2189c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded2189c",
  null
  
)

export default component.exports